import * as React from 'react';
import Accordion, { AccordionProps } from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Divider } from '@mui/material';
import { styled as _styled } from '@mui/material/styles';
import styled from "styled-components";
import { theme } from "../../../../../helpers/theme";

export type CollapseFaqArrayProps = {
    key: number;
    question: string;
    answer: React.ReactNode;
    content: string;
    header: string;

};
export interface CollapseInfoProps {
    questionList: CollapseFaqArrayProps[];
};


export const CollapseInfo = ({ questionList }: CollapseInfoProps) => {
    const [expanded, setExpanded] = React.useState<string | false>(false);
    const handleChange =
        (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
            setExpanded(isExpanded ? panel : false);
        };

    return (
        <ContainerFaq>
            {questionList.map(item =>
                <StyledAccordion
                    sx={{
                        backgroundColor: `${theme.colors.gray04_background}`,
                    }}
                    disableGutters
                    key={item.key}
                    expanded={expanded === `${item.key}`}
                    onChange={handleChange(`${item.key}`)}>
                    <AccordionSummary
                        expandIcon={
                            <ExpandMoreIcon
                                sx={{
                                    color: `${theme.colors.gray01_secondaryText}`,
                                    '&:hover': {
                                        color: `${theme.colors.black_primaryText}`
                                    },
                                }} />}
                        aria-controls={item.content}
                        id={item.header}
                        sx={{
                            color: `${theme.colors.black_primaryText}`,
                            backgroundColor: `${theme.colors.gray04_background}`,
                        }}
                    >
                        <Typography sx={{
                            width: '100%',
                        }}>
                            <Title> {item.question}</Title>
                        </Typography>

                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography
                            sx={{

                            }}
                        >
                            {item.answer}
                        </Typography>
                    </AccordionDetails>
                </StyledAccordion >
            )}

        </ContainerFaq>

    );
};

const Title = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.big};
font-size: 16px;
line-height: 24px;
color: ${theme.colors.black_primaryText};
`;

const ContainerFaq = styled.div`
//padding-bottom:30px;
`;

const StyledAccordion = styled((props: AccordionProps) => (
    <Accordion {...props}>{props.children}</Accordion>
))(({ }) => ({
    backgroundColor: 'green',
    borderRadius: '8px !important',
    marginBottom: '5px',
}));

const AccordionSummary = _styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ }) => ({

    '& .Mui-expanded': {
        //color: `${theme.colors.black_primaryText}`,
        '& p': {
            //color: `${theme.colors.black_primaryText}`,
        }
    },
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        '& svg': {
            //color: `${theme.colors.black_primaryText}`,
        }
    },

}));
